__turbopack_context__.v({
  "innerWrapper": "BoardSectionItemFeed-module-scss-module__eNOKIq__innerWrapper",
  "item": "BoardSectionItemFeed-module-scss-module__eNOKIq__item",
  "wrapper": "BoardSectionItemFeed-module-scss-module__eNOKIq__wrapper",
});
